import PackingAPI from 'api/packing';
import { action, observable, runInAction } from 'mobx/lib/mobx';
import { getLocalizedString } from 'i18n/utils';

const NAME = 'name';
const AMOUNT = 'amount';
const UNIT = 'unit';

export const TABLE_FORMAT = [
  {
    name: getLocalizedString('supplier.data.name'),
    property: NAME,
    variant: ['left'],
  },
  {
    name: getLocalizedString('packing.edit.amount'),
    property: AMOUNT,
    variant: ['left'],
  },
  {
    name: getLocalizedString('packing.edit.unit'),
    property: UNIT,
    variant: ['left'],
  },
];

class PackingStore {
  tableFormat = TABLE_FORMAT;
  @observable data = [];
  @observable loading = true;
  @observable paginateOptions = {};
  @observable paginateData = { page: 0, size: 20 };
  @observable allFilters = {
    name: '',
  };

  @action
  changeAllFilters = (key, value) => {
    const allFilters = { ...this.allFilters };
    runInAction(() => {
      allFilters[key] = value;
      this.allFilters = allFilters;
    });
  };

  @action
  changePaginateData = value => {
    runInAction(() => {
      this.paginateData = { ...value };
    });
  };

  @action
  fetchData = async () => {
    const { page, size } = this.paginateData;
    const { items, last, totalPages, totalElements } = await PackingAPI.list(
      page,
      size,
      this.allFilters,
    );

    runInAction(() => {
      this.data = items;
      this.paginateOptions = {
        last,
        totalElements,
        totalPages,
        onPageChange: (page, size) => {
          this.changePaginateData({ page, size });
        },
      };

      this.loading = false;
    });
  };

  @action
  deletePacking = async id => {
    try {
      await PackingAPI.delete(id);
    } catch (error) {
      throw new Error(error.message);
    }
    runInAction(() => {
      this.data = this.data.filter(i => i.id !== id);
    });
  };
}

export default PackingStore;
